import React from 'react';
import PropTypes from 'prop-types';
import Logger from '../../utils/logger';
import './Icon.scss';

let loader = null;

class Icon extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    component: PropTypes.func,
    fill: PropTypes.string,
    height: PropTypes.string,
    iconClass: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    role: PropTypes.string,
    ariaLabel: PropTypes.string,
    ariaHidden: PropTypes.string,
    url: PropTypes.string,
    width: PropTypes.string,
    tabIndex: PropTypes.string,
  };

  static defaultProps = {
    className: null,
    component: null,
    fill: null,
    height: '1em',
    iconClass: null,
    id: undefined,
    name: null,
    ariaLabel: undefined,
    ariaHidden: undefined,
    role: undefined,
    url: null,
    width: '1em',
    tabIndex: undefined,
  };

  state = { Svg: this.props.component }; // eslint-disable-line

  componentDidMount = async () => {
    const {
      component,
      iconClass,
      name,
      url,
    } = this.props;

    if (component) {
      if (!(iconClass || name)) {
        Logger.error('[ERROR] When providing a component, you must also provide a name or iconClass');
      }
    } else if (url) {
      this.loadFromUrl(url);
    } else if (loader) {
      const Svg = await loader(name);
      this.setState({ Svg });
    } else {
      Logger.error('[ERROR] You need to set a loader function with IconLoader');
    }
  }

  componentDidUpdate = async (prevProps) => {
    const { component, name } = this.props;
    if (prevProps.component !== component) {
      const Svg = await loader(name);
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ Svg });
    }
  }

  loadFromUrl = async (url) => {
    try {
      const response = await fetch(url);
      const Svg = await response.text();
      this.setState({ Svg });
    } catch (error) {
      Logger.error(`[ERROR] Icon.loadFromUrl: ${error}`);
    }
  }

  renderInnerHTML = (icon) => {
    if (icon) {
      const { Svg } = this.state;
      icon.innerHTML = Svg; // eslint-disable-line
    }
  }

  renderWithStyles = () => {
    const { Svg } = this.state;
    const {
      fill, height, width, role, ariaLabel, ariaHidden, tabIndex,
    } = this.props;
    const props = {
      height,
      width,
      role,
      'aria-label': ariaLabel,
      'aria-hidden': ariaHidden,
      tabIndex,
    };

    if (fill) {
      props.fill = fill;
    }

    Svg.displayName = 'Svg';

    return <Svg {...props} />;
  }

  render() {
    const { Svg } = this.state;

    if (!Svg) {
      return null;
    }

    const {
      className,
      iconClass,
      id,
      name,
      url,
    } = this.props;
    let classes = `ResyIcon ResyIcon--${iconClass || name}`;

    if (className) {
      classes = classes.concat(` ${className}`);
    }

    if (url) {
      return (
        <i
          className={classes}
          id={id}
          ref={this.renderInnerHTML}
          data-testid={`icon-${name}`}
        />
      );
    }

    return (
      <i data-testid={`icon-${name}`} className={classes} id={id}>
        {this.renderWithStyles()}
      </i>
    );
  }
}

const IconLoader = (loaderFn) => {
  loader = loaderFn;
};

Icon.displayName = 'Icon';
export default Icon;
export { IconLoader };
